<template>
 
    <div class="meun-main" >

      <div class="meun-main-seach" >
        <img src="@/assets/logoh5new.png" alt="">
        
          <!-- 搜索框 -->
          <div class="input-container">
            <!-- 搜索图标 -->
            <i id="iconsearch" class="el-icon-search"></i>
            <!-- 输入框 -->
            <input type="text" placeholder="Enter your information" name="search2">
            <button type="submit">search</button>
          </div>
       
      </div>

      <div class="meun-main-product">
       <div class="meunw">
            <div class="meuw-index" >
                <div class="meu-indexfu" style="margin-top: 5vh;" >
                <div  :class="{ 'active': activeCategory === category }" class="meuw-index-content" v-for="(category, index) in Object.keys(categories)" :key="index" @click="selectCategory(category)">  {{ category }} series</div>
               
                </div>
            </div>

            <div class="meuw-item" >
                <div class="meuw-itemfu" style="margin-top: 5vh;">
                    <!-- 渲染当前选中系列的商品 product==={ name: "20寸商务旅行箱", price: "￥2999", image: require("@/assets/meuw-itemfu-item-content.png") , minimage: require("@/assets/meuw-itemfu-item-content.png")},-->
                    <div class="meuw-itemfu-item"  v-for="(product, index) in activeProducts" :key="index" 
                    :style="{
                        height: product.color.length <= 1 ? '28vh' : (product.minimage === '' ? '30vh' : undefined),
                        marginBottom: activeProducts.length === index + 1 ? '10vh' : '0'
                      }">
                        <div class="meuw-itemfu-item-content"  
                        :style="product.color.length <= 1 ? { height: '5.2vh' } : null,
                            product.minimage=='' ? { height: '12vh' } : null"></div>
                        <div class="meuw-itemfu-item-title">{{ product.name }}</div>

                        <div class="meuw-itemfu-item-position">

                            <div class="meuw-itemfu-item-positionleft">
                                <div class="meuw-itemfu-item-positionleft-img">
                                    <img :src="product.image" alt=""></div>
                                <div class="meuw-itemfu-item-positionleft-dot" v-if="product.color.length > 1">
                                    <!-- <div class="-dot -black"></div>["black","#ffffcc","white","purple"]
                                    <div class="-dot -white"></div> -->
                                    <div v-for="(colors, index2) in product.color" :key="index2" 
                                    class="-dot" 
                                    :style="{ backgroundColor: colors, border: colors === 'white' ? '1px solid black' : 'none'}"></div>

                                </div>
                                <div class="meuw-itemfu-item-positionleft-price" v-if="product.minimage !=''">{{ product.price }}</div>
                            </div>

                            <div class="meuw-itemfu-item-positionright" :style="product.color.length < 1 ? { height: '78%' } : {},product.minimage=='' ? { height: '78%' } : null">
                                <div class="meuw-itemfu-item-positionright-img">
                                    <img :src="product.minimage" alt="" v-if="product.minimage">
                                    <div class="elsenoproductfu" v-else :style="product.minimage==''&&product.color.length > 1 ? { height: '3vh' } : null">
                                       
                                      <div v-if="product.minimage==''" class="elsenoproductfu-price" style="color: black;" >{{ product.price }}</div>  
                                    </div>
                                                                         

                                </div>
                                <div class="meuw-itemfu-item-positionright-button" ><button :style="product.color.length <= 1 ? { height: '70%'}:{},product.minimage=='' ? { height: '70%' } : null"  @click="goshopping(product.productnnumber)">shop</button></div>
                            </div>
                      </div>

                    </div>

                    

                </div>
            </div>
       </div>
       
      </div>
      
  
    <div style="width: 100vw;">
      <bottomh5></bottomh5>
    </div>
</div>
  </template>
<script>
 import bottomh5 from'@/view/h5/public/bottomh5en.vue'
 import axios from 'axios';
 import apiUrls from '@/http/http';
export default {
    components:{
          bottomh5
        },
  data() {
    return {
      // 各个系列的商品信息
      categories: {
        "P": [
          {productnnumber: 0, name: "20-inch aluminum-magnesium alloy business travel suitcase", price: "￥3599", image:  require("@/assets/meuw-itemfu-item-content.png"), minimage: require("@/assets/meuw-itemfu-item-positionright-img22.png"),color:["black","white","blue","green","purple","brown"]},
          // {productnnumber: 0, name: "18-inch aluminum-magnesium alloy business travel suitcase", price: "￥3499", image: require("@/assets/meuw-itemfu-item-content2.png") , minimage: require("@/assets/meuw-itemfu-item-contentzip2.png"),color:["black","white","blue","green","purple","brown"]},
        ],
        // "U": [
        //   {productnnumber: 0, name: "20 inch PC business travel case", price: "￥1199", image: require("@/assets/meuw-itemfu-item-content3.png") , minimage: require("@/assets/meuw-itemfu-item-contentzip3.png"),color:["black","white","gray","lightblue"]},
        // ],
        // "K": [
        //   {productnnumber: 0, name: "K02 commuter backpack", price: "￥399", image: require("@/assets/meuw-itemfu-item-content4.png"), minimage: '' ,color:["black"]},
        //   {productnnumber: 0, name: "K03 Commuter Briefcase", price: "￥359", image: require("@/assets/meuw-itemfu-item-content5.png"), minimage: '' ,color:["black"]},
        // ],
        // "E": [
        //   {productnnumber: 0, name: "E01 PC suitcase", price: "￥639", image: require("@/assets/meuw-itemfu-item-content6.png") , minimage: '',color:["black","#ffffcc","purple","green","red"]},
        //   {productnnumber: 0, name: "E02 PC suitcase", price: "￥939", image: require("@/assets/meuw-itemfu-item-content7.png"), minimage: '',color:["black","gray","white","blue"] },
        //   {productnnumber: 0, name: "E03 PC suitcase", price: "￥1199", image: require("@/assets/meuw-itemfu-item-content8.png"), minimage: '',color:["black","#ffffcc","purple","green","red"]},
        // ],
        // "C": [
        //   {productnnumber: 0, name: "E01 PC suitcase", price: "￥639", image: require("@/assets/meuw-itemfu-item-content9.png") , minimage: '',color:["black","#ffffcc","purple","green","red"]},
        // ],
      },
      // 当前选中的系列
      activeCategory: "P",
    };
  },
  mounted() {
    this.fetchData();
  },
  computed: {
    // 获取当前选中系列的商品this.activeCategory='U'
    //this.categories[U]==vaule     map<key,vaule>
    //return vaule
    //return  { name: "20寸商务旅行箱", price: "￥2999", image: require("@/assets/meuw-itemfu-item-content.png") , minimage: require("@/assets/meuw-itemfu-item-content.png")},
         // { name: "28寸旅行拉杆箱", price: "￥4999", image: require("@/assets/meuw-itemfu-item-content.png") , minimage: require("@/assets/meuw-itemfu-item-content.png")},
       
         activeProducts() {
      return this.categories[this.activeCategory] || [];  // 获取当前选中分类的商品
    },
  },
  methods: {

     // 跳转到购物表单页面
     goshopping(names) {
      //路由跳转 如果需要传递参数
       this.$router.push({ name: 'goshoppingen', query: { productsname: names } });
    },

    // 点击系列时更新选中的系列 u
    selectCategory(category) {
      this.activeCategory = category;
    },


    async fetchData() {
            try {
                // 发起 API 请求
                const response = await axios.get(`${apiUrls.baseUrl}/website/api/productrange`);
                const data = response.data;
                
                if (data && data.length > 0) {
                    // 更新分类信息
                 this.updateCategories(data);
                 
                   
                }
            } catch (error) {
                console.error('获取数据失败:', error);
            }
        }, 
        updateCategories(data) {

// 清空当前的 categories 数据
this.categories = {};

                // 遍历每个产品项并更新到对应的分类
              data.forEach(item => {
                  const category = item.classificationen; // 获取分类信息

                  // 如果分类不存在，则新建分类
                  if (!this.categories[category]) {
                      this.categories[category] = [];
                  }

                  // 将商品添加到对应的分类中
                  this.categories[category].push({
                    productnnumber: item.productnnumber,
                      name: item.categoriesnameen,
                      price: item.categoriespriceen,
                      image: item.categoriesimage?`${apiUrls.devApi}${item.categoriesimage}`:'',
                      minimage: item.categoriesminimage?`${apiUrls.devApi}${item.categoriesminimage}`:'',
                      color: item.color.split(',')
                  });
                  
              });
              // console.log(this.categories)
              // 默认选中第一个分类
              if (Object.keys(this.categories).length > 0) {
                  this.activeCategory = Object.keys(this.categories)[0];
              }

              },
  },
};

</script>


  <style scoped>
  /deep/.el-menu{
    padding-left: 3.5vw;
  }
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  
  body {
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .meun-main {
    position: absolute !important;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: hidden; /* 允许滚动 */
    background-color: white; /* 根据需要调整 */
  }


   /* 搜素区域开始 */
  .meun-main {
    background-color: rgb(50, 50, 50);
   
  }
  
  .meun-main-product {
    width: 100vw;
    background-color: white;
    border-radius: 30px 30px 0 0; /* 左上 右上 右下 左下 */
    padding-top: 1vh;
    height: calc(100vh - 100px);

    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .meun-main-seach {
    width: 100vw;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center; /* 垂直居中 */
    justify-content: center; /* 水平居中 */
    gap: 13px;

    margin-bottom: 0.5vh;
   
  }
  
  .meun-main-seach img {
   
    width: auto;
    height: 20px;
   
  }
  
  /* 搜索框 */
  
  .input-container {
    width: 90%;
    display: flex;
    align-items: center;
    position: relative;
    margin: 0;
    padding: 0;
    height: 4.5vh;
    box-sizing: border-box; /* 确保高度计算包含 padding */
  }
  
  .input-container input {
    height: 100%;
    width: 100%;
    background-color: rgb(196, 196, 196);
    border-radius: 30px;
    border: 0px;
    padding-left: 3rem; /* 留出空间给图标 */
    box-sizing: border-box; /* 确保内边距不会影响高度 */
  }
  
  /* 搜索图标 */
  #iconsearch {
    position: absolute;
    left: 1rem; /* 图标在输入框左侧的位置 */
    font-size: 1.5rem;
    color: gray;
  }
  
  /* 按钮样式 */
  .meun-main-seach .input-container button {
    position: absolute;
    right: 0; /* 按钮与输入框右对齐 */
    height: 100%; /* 确保按钮与输入框高度一致 */
    width: 15vw;
    border-radius: 30px;
    background-color: rgb(91, 91, 91);
    border: 0px;
    color: white;
    letter-spacing: 1px;
    white-space: nowrap; /* 禁止文字换行 */

  }
     /* 搜素区域结束 */
      /* 商品区域开始*/
     .meunw{
        height:100%;
        width: 98%;

        display: flex;
        justify-content: center;
        align-items: center;
       
     }
     .meuw-index {
        height: 100%;
        width: 26vw;
        background-color: rgb(242, 242, 242);
        border-radius: 30px 0 0 0; /* 左上 右上 右下 左下 */
     }
     .meuw-item{
        height: 100%;
        width: 70vw;
        overflow-y: auto;
     }
     .meu-indexfu{
        display: flex;
        flex-direction: column;
        gap: 2vh;
     }
  
     .meuw-index-content.active{
       
        height: 9vh;
        width: 100%;
        background-color: white;
        color: black;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center; /* 垂直居中 */
        align-items: center; /* 垂直居中 */
         border-radius: 0 0 5px 5px; /* 左上 右上 右下 左下 */
        box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* 添加底部阴影 */

     }
     .meuw-index-content{
       
        height: 9vh;
        width: 100%;
        
        color: gray;
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center; /* 垂直居中 */
       

     }
     .meuw-itemfu{
        display: flex;
        flex-direction: column;
      
        height: atuo;

        display: flex;
        flex-direction: column;
        /*水平居中*/
        align-items: center;

        padding-bottom: 20px;  /* 增加底部间距避免内容被裁切 */
        overflow-y: auto; /* 确保内容能滚动 */
        gap: 3vh;
     }
     .meuw-itemfu-item{
        
        height: 34vh;
        width: 90%;
       

        display: flex;
        flex-direction: column;
        justify-content: flex-end; /* 将子元素推到父容器的底部 */
        gap: 2vh;

        position: relative;
       
     }
     .meuw-itemfu-item-content{
        height: 14vh;
        width: 90%;
        background-color: rgb(242, 242, 242);
        align-self: flex-end;
     }
     .meuw-itemfu-item-title{
        height: 3vh;
        width: 100%;
        text-align: center;
        color: #8a8787;
     }

     .meuw-itemfu-item-position{
        position: absolute;
        top: 0vh;
        height: 27vh;
        width: 100%;

        display: flex;
        
     }

     .meuw-itemfu-item-positionleft{
        height: 100%;
        width: 60%;
       
     }
     .meuw-itemfu-item-positionleft-img{
        height: 78%;
        width: 100%;
       
       
        background-color: rgb(242, 242, 242);
     }
     .meuw-itemfu-item-positionleft-img img {
        
        height: 100%;
        width: 100%;
        border-radius: 0 0 30px 0; /* 左上 右上 右下 左下 c*/
        box-shadow: 1px 2px 1px rgba(0, 0, 0, 0.3); /* 水平偏移 垂直偏移 模糊半径 颜色 */
    }

     .meuw-itemfu-item-positionleft-dot{
       
        width: 100%;
        margin-top: 1.5vh;

        display: flex;
        align-items: center;     /* 垂直居中 */
         /*justify-content: center;*/
        gap: 1vw; /* 调整圆点之间的间距 */
        padding-left: 13vw;
     }
     .meuw-itemfu-item-positionleft-price{
        text-align: center;
        color: black;
        margin-top: 0.9vh;
     }
     .-dot {
        width: 1.2vh; /* 圆点的宽度 */
        height: 2.4vw; /* 圆点的高度 */
        border-radius: 50%; /* 创建圆形 */

       
      }
      .-black{
        background-color: black;
      }
      .-white{
        background-color: white;
        border: 1px solid black; /* 添加黑色实线上边框 */
      }
      .-blue{
        background-color: blue;
      }
      .-green {
        background-color: green;
      }
      .-purple {
        background-color: purple;
      }
      .-brown {
        background-color: brown;
      }

      .meuw-itemfu-item-positionright{
        height: 100%;
        width: 40%;
        
      }
      .meuw-itemfu-item-positionright-img{
        height: 80%;
        width: 100%;
       

        display: flex;          /* 设置为 Flex 容器 */
        justify-content: center;/* 水平居中图片 */
        align-items: flex-end;  /* 将图片垂直对齐到底部 */
      }
      
      .meuw-itemfu-item-positionright-img img{
        
        width: 80%;
      }
      .meuw-itemfu-item-positionright-button{
        height: 20%;
        width: 100%;
       

        display: flex;
        justify-content: center;
        align-items: flex-end;
      }
      .meuw-itemfu-item-positionright-button button{
        height: 55%;
        width: 58%;
        background-color: black;
        border-radius: 7px; /* 左上 右上 右下 左下 */
        border: 0;
        box-shadow: 0px 0px 1px black;
        color:#b7b4b4;
        font-size:0.7rem;
       
      }
.elsenoproductfu{
    display: flex;
    flex-direction: column; /* 设置主轴方向为垂直 */
    justify-content: center; /* 主轴上的居中对齐，这里是垂直居中 */
    align-items: center;     /* 交叉轴上的居中对齐，这里是水平居中 */
    height:7vh;            /* 确保父容器有足够高度以允许子元素居中 */
    width: 100%;             /* 父容器宽度设为100%或根据需要调整 */
    gap: 2vh;
}
.elsenoproductfu-dot{
    width: 2.4vw;
    height: 1.2vh;
    background-color: black;
    border-radius: 50%;
}
.elsenoproductfu-price{
    width: auto;
    height: 2vh;
}
      /* 商品区域结束*/
  </style>
  